import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import star from './assets/star.png'
import starRetina from './assets/star@2x.png'
import starActive from './assets/star-active.png'
import starActiveRetina from './assets/star-active@2x.png'

const Rating = ({ rating, dpr }) => {
  const percentage = Math.round(rating * 20.0)
  const retina = ((typeof window !== 'undefined' && window.devicePixelRatio) || dpr) >= 2

  return (
    <div className='result-rating'>
      <div className='background'>
        <img src={retina ? starRetina : star} width='70' height='12' alt='star icon' />
      </div>
      <div className='active' style={{ width: `${percentage}%`, overflow: 'hidden' }}>
        <img
          src={retina ? starActiveRetina : starActive}
          width='70'
          height='12'
          alt='active star icon'
          className='active-star'
        />
      </div>
    </div>
  )
}

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
  dpr: PropTypes.number.isRequired
}

export default Rating
